import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";

/** Simple | Classic (2.2): the platform default for the admin on 13thav, a shop's own override for an owner. */
export default function ModeSwitch({ scope, override, light = false }) {
    const platform = useSettings()?.site_mode || "simple";
    const mode = scope === "platform" ? platform : (override || platform);
    const [busy, setBusy] = useState(false);
    const pick = async (next) => {
        if (next === mode || busy) return;
        setBusy(true);
        try {
            if (scope === "platform") await api.put("/admin/site-mode", { site_mode: next });
            else await api.put("/stores/me/site-mode", { site_mode: next });
            window.location.reload();
        } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); setBusy(false); }
    };
    const on = light ? "bg-[#1a1a1a] text-white" : "bg-white text-[#1a1a1a]";
    const off = light ? "text-[#1a1a1a]" : "text-white/75 hover:bg-white/15 hover:text-white";
    return (
        <div role="radiogroup" aria-label="Site mode" data-testid="site-mode-switch"
            className={`inline-flex border p-0.5 text-[12px] font-semibold ${light ? "min-h-[44px] items-center border-[#1a1a1a]" : "border-white/70"}`}>
            {["simple", "classic"].map((m) => (
                <button key={m} role="radio" aria-checked={mode === m} onClick={() => pick(m)} disabled={busy}
                    data-testid={`site-mode-${m}`}
                    className={`px-2.5 py-1 capitalize ${light ? "min-h-[36px]" : ""} ${mode === m ? on : off}`}>
                    {m}
                </button>
            ))}
        </div>
    );
}
